import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<void, "optionLabel">()((theme) => ({
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  optionButtonContainer: {
    position: "relative",
  },
  optionButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
  optionIcon: {
    width: "3rem",
    height: "3rem",
    border: "2px solid #d2d2d7",
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
    transition: "all 0.2s",
    position: "relative",

    "& svg": {
      width: theme.spacing(6),
      height: theme.spacing(6),
      stroke: "#86868b",
    },
  },
  selected: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    backgroundColor: "rgba(255, 58, 75, 0.05)",

    "& span": {
      color: theme.palette.secondary.main,
    },

    "& svg": {
      stroke: theme.palette.secondary.main,
    },
  },
  disabled: {
    color: "#d2d2d7",
    borderColor: "#d2d2d7",
    backgroundColor: "transparent",
    cursor: "pointer",
    opacity: 0.5,
  },
  optionText: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#86868b",
  },
  optionLabel: {
    fontSize: "0.625rem",
    color: "#0a1a2f",
  },
  fileInput: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0,
    cursor: "pointer",
    zIndex: 1,
  },
  locked: {
    position: "absolute",
    right: theme.spacing(0.75),
    top: theme.spacing(0.75),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    borderRadius: "50%",
    padding: theme.spacing(0.375),
    color: "#535353",
    pointerEvents: "none",

    "& svg": {
      width: "10px",
      height: "10px",
      fill: "currentColor",
    },
  },
  clickOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    cursor: "pointer",
    zIndex: 10,
  },
  tooltip: {
    position: "fixed",
    backgroundColor: "white",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    paddingTop: theme.spacing(5),
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e5e5e7",
    zIndex: 1400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    minWidth: 200,
    animation: "fadeIn 0.2s ease",

    "@keyframes fadeIn": {
      from: { opacity: 0, transform: "translateY(-5px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
  },
  tooltipClose: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    width: 24,
    height: 24,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "#f5f5f5",
    color: "#86868b",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
    transition: "all 0.2s",

    "&:hover": {
      backgroundColor: "#e5e5e7",
    },
  },
  tooltipMessage: {
    margin: 0,
    fontSize: "0.875rem",
    color: "#0A1A2F",
    textAlign: "center",
  },
  tooltipUpgrade: {
    padding: theme.spacing(1.5, 4),
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    border: "none",
    borderRadius: "1rem",
    fontSize: "0.75rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));
